/** @jsxImportSource @emotion/react */
import { css, keyframes } from '@emotion/react'
import { useEffect, useState } from 'react'
import { API_BASE_URL } from 'config'

type StatusResponse = {
    isMaintenance: boolean
    message: string
}

export const MaintenanceBanner = () => {
    const [status, setStatus] = useState<StatusResponse | null>(null)

    useEffect(() => {
        const fetchStatus = async () => {
            try {
                const response = await fetch(`${API_BASE_URL}/info/status`)
                if (response.ok) {
                    const data = await response.json()
                    setStatus(data)
                }
            } catch (error) {
                console.error('Failed to fetch maintenance status:', error)
            }
        }

        fetchStatus()
    }, [])

    if (!status?.isMaintenance) {
        return null
    }

    return (
        <div css={bannerWrapperCss}>
            <div css={marqueeCss}>
                <span>{status.message}</span>
            </div>
        </div>
    )
}

const bannerWrapperCss = css`
    background-color: #fff1b8;
    color: #856404;
    overflow: hidden;
    white-space: nowrap;
    padding: 8px 0;
    font-weight: bold;
    font-size: 0.9rem;
    position: sticky;
    top: 0;
    z-index: 1001;
`

const scrollAnimation = keyframes`
    0% { transform: translateX(100%); }
    100% { transform: translateX(-100%); }
`

const marqueeCss = css`
    display: inline-block;
    padding-left: 100%;
    animation: ${scrollAnimation} 15s linear infinite;

    span {
        padding-right: 50px; /* Space between loops if needed, but here it just loops the whole thing */
    }
`
